export default Object.freeze({
  // SETTLEMENT_
  PARTNER_TYPE: '파트너구분',
  PARTNER_TYPE_DOMESTIC: '국내 파트너',
  PARTNER_TYPE_OVERSEAS: '해외 파트너',
  TAX_TYPE_DUTY: '과세',
  SALE_METHOD_CONSIGNMENT: '위탁',
  SALE_METHOD_PURCHASE: '사입',

  EXCEL_ORDER_NO: '주문번호',
  EXCEL_PARTNER_NAME: '파트너사',
  EXCEL_COMPANY_NAME: '회사명',
  EXCEL_PARTNER_TYPE: '파트너 구분',
  EXCEL_VALUE_ADDED_TAX_TYPE_LABEL: '과세유형',
  EXCEL_MALL_PRODUCT_NO: '상품번호',
  EXCEL_PRODUCT_NAME: '상품명',
  EXCEL_SALE_METHOD_TYPE_LABEL: '판매방식',
  EXCEL_OPTION_MANAGEMENT_CD: '옵션관리코드',
  EXCEL_OPTION: '옵션명',
  EXCEL_SETTLEMENT_DELIVERY_TYPE_LABEL: '배송구분(배송번호)',
  EXCEL_CLAIM_NO: '클레임번호',
  EXCEL_IMMEDIATE_DISCOUNTED_PRICE: '판매가(할인적용가)',
  EXCEL_ORDER_CNT_BY_PRODUCT: '판매수량',
  EXCEL_REFUND_CNT: '환불수량',
  EXCEL_SALES_AMT: '판매액(A)',
  EXCEL_PURCHASE_YN: '공급가 입력',
  EXCEL_PURCHASE_AMT_EXCEL: '공급가액(O)',
  EXCEL_SUPPLY_AMT_EXCEL: '매입가액(P)',
  EXCEL_COMMISSION_RATE_EXCEL: '수수료율(B)',
  EXCEL_COMMISSION_AMT_EXCEL: '판매수수료(C=A*B or A-(O or P))',
  EXCEL_MALL_DISCOUNT_AMT: '추가/상품할인 쇼핑몰분담',
  EXCEL_PARTNER_DISCOUNT_AMT: '추가/상품/사은품할인파트너부담(D)',
  EXCEL_MALL_PRODUCT_ADJUST_AMT: '상품금액조정 쇼핑몰부담',
  EXCEL_PARTNER_PRODUCT_ADJUST_AMT: '상품금액조정 파트너부담(E)',
  EXCEL_MALL_DELIVERY_ADJUST_AMT: '배송비금액조정 쇼핑몰부담',
  EXCEL_PARTNER_DELIVERY_ADJUST_AMT: '배송비금액조정 파트너부담(F)',
  EXCEL_MALL_DELIVERY_AMT: '쇼핑몰배송비(G)',
  EXCEL_REFUND_ADJUST_AMT: '환불보류 금액조정(H)',
  EXCEL_SETTLEMENT_AMT_BY_PRODUCT: '옵션 매출금액(I=A-C-D-E-F-G+H)',
  EXCEL_PAY_YMDT: '결제완료일',
  EXCEL_REGISTER_YMDT: '매출집계일',
  EXCEL_MEMO: '비고'
});
